import { removeItem } from "@/utils/va-order-test/testAndPanelSelection";
import { handleCustomPanelSelection } from "@/utils/va-order-test/testAndPanelSelection/customPanelSelection";
import { getTestIdsInPanel, handleDiscountPanelSelection } from "@/utils/va-order-test/testAndPanelSelection/discountPanelSelection";
import { handleShortcutSelection } from "@/utils/va-order-test/testAndPanelSelection/shortcutSelection";
import { handleTestSelection } from "@/utils/va-order-test/testAndPanelSelection/testSelection";
import { handleXChooseYSelection } from "@/utils/va-order-test/testAndPanelSelection/xChooseYPanelSelection";
import { handleSeasonalPromoSelection } from "@/utils/va-order-test/testAndPanelSelection/seasonalPromoSelection";
import store from "@/store";
import { getVerifyCouponApiPayload } from "@/views/va-orderTest/checkout-page/price-summary/components/promoCode";
import { verifyCouponCodeApi } from "@/api/va-order-page/pricing/item/promotion";
import { parseJson } from '@/utils';

export function getEditOrderItemsForDisplay(itemList, supportObj) {
  let editOrderItems = [];

   // add category & do any necessary modifications for frontend use
   itemList.forEach(item => {
    if (item.item_type === "shortcutId") {
      item.category = "shortcut";
      item.shortcutName = item.item_name;
    }
    if (item.item_type === "packagePriceId") {
      item.category = item.vaVwType === "VA" ? "va" : "vw";
      // handle id for duplicate item ids
      let { package_id, item_id } = item;
      if (package_id) {
        item.item_id = [item_id, package_id].join("_");
      }
    }
    if (item.item_type === "bundleId") {
      if (item.x_choose_y_List) {
        item.category = "xChooseY";
        item.bundleId = item.item_id;
        item.bundleName = item.item_name;
        let xChooseYDetails = [];
        let supplementDetails = [];
        let xChooseYTestIds = [];
        let supplementIds = [];
        let { x_choose_y_List, supplement_x_choose_y_List } = item;
        if (x_choose_y_List && x_choose_y_List[0]) {
          let details = x_choose_y_List[0].x_choose_y_detail_list;
          xChooseYDetails = details ? xChooseYDetails.concat(details) : xChooseYDetails;
          xChooseYTestIds = xChooseYDetails.map(detail => detail.item_id);
        }
        if (supplement_x_choose_y_List && supplement_x_choose_y_List[0]) {
          let details = supplement_x_choose_y_List[0].x_choose_y_detail_list;
          supplementDetails = details ? supplementDetails.concat(details) : supplementDetails;
          supplementIds = supplementDetails.map(detail => detail.item_id);
        }
        item.xChooseYDetails = xChooseYDetails;
        item.supplementDetails = supplementDetails;
        item.xChooseYTestIds = xChooseYTestIds;
        item.supplementIds = supplementIds;
      } else {
        item.category = item.itemOldType === "DISCOUNTPANEL" ? "discountPanel" : "customPanel";
        item.bundleId = item.item_id;
        item.bundleName = item.item_name;
        item.testIdsInPanel = getTestIdsInPanel(item.item_id, supportObj.bundleList, item.category);
      }
    }
    // modify item price if it has markup
    if (item.markup_version || item.markup_version === 0) {
      let { markup_version, markup, total } = item;
      item.markupVersion = markup_version;
      item.markupPrice = markup;
      item.total = total - markup;
    }
    item.id = item.item_id;
    item.price = item.total;
    item.originalPrice = item.original_price;
    item.customizedName = item.customized_name;
   });

  // handle for shortcut
  let shortcuts = itemList.filter(item => item.item_type === "shortcutId");
  shortcuts.forEach(shortcut => {
    // find items in itemList belong to current shortcut
    let shortcutItems = itemList.filter(item => item.shortcut_id === shortcut.item_id);
    if (shortcutItems.length > 0) {
      let shortcutPrice = shortcutItems.reduce((acc, item) => acc + item.total, 0);
      shortcut.total = shortcutPrice;
      editOrderItems.push({ ...shortcut, contents: shortcutItems });
    }
  });

  // handle for promotions
  let promotionIds = new Set(itemList.filter(item => item.promotion_coupon_id).map(item => item.promotion_coupon_id));
  promotionIds.forEach(promoId => {
    let promotionOnMenu = supportObj.seasonalPromotionList.find(p => p.id === promoId);
    let contents = itemList.filter(item => item.promotion_coupon_id === promoId);
    if (promotionOnMenu) {
      editOrderItems.push({
        item_id: promoId,
        item_name: promotionOnMenu.discountName,
        category: "seasonalPromo",
        contents,
        total: contents[0].total,
        markupVersion: contents[0].markupVersion,
        markupPrice: contents[0].markupPrice,
      });
      contents.forEach(content => removeItem(content, itemList));
    }
  });

  // handle rest of the items
  let itemsNotInShortcuts = itemList
    .filter(item => item.item_type !== "shortcutId" && !item.shortcut_id);
  editOrderItems = editOrderItems.concat(itemsNotInShortcuts);
  return editOrderItems;
}

// select/de-select edit order items that available on current menu
// according to isSelect value
export function handleEditOrderItemSelection(item, isSelect, supportObj) {
  let { testNodeList, shortcutList, seasonalPromotionList } = supportObj;
  switch (item.category) {
    case "va":
    case "vw":
      selectTestInEditOrder(item, isSelect, testNodeList);
      break;
    case "discountPanel":
      handleDiscountPanelSelection(item.item_id, "isSelect", isSelect, supportObj);
      break;
    case "xChooseY":
      selectXChooseYPanelInEditOrder(item, isSelect, supportObj);
      break;
    case "customPanel":
      handleCustomPanelSelection(item.item_id, "isSelect", isSelect, supportObj);
      break;
    case "shortcut": {
      // TODO: check ordered shortcut contents with current one before select
      let shortcutOnMenu = shortcutList.find(s => s.id === item.item_id);
      if (shortcutOnMenu) {
        item.item_name = shortcutOnMenu.shortcutName; // update name
        handleShortcutSelection(item.item_id, "isSelect", isSelect, supportObj);
      } else {
        // select shortcut contents
        item.contents.forEach(content => handleEditOrderItemSelection(content, isSelect, supportObj));
      }
      break;
    }
    case "seasonalPromo": {
      let seasonalPromoOnMenu = seasonalPromotionList.find(promo => promo.id === item.item_id);
      if (seasonalPromoOnMenu) {
        let promoTests = item.contents.filter(c => c.item_type === "packagePriceId");
        let promoBundles = item.contents.filter(c => c.item_type === "bundleId");
        seasonalPromoOnMenu.appliedTests = new Set(promoTests.map(t => t.item_id));
        seasonalPromoOnMenu.appliedBundles = new Set(promoBundles.map(b => b.item_id));
        handleSeasonalPromoSelection(seasonalPromoOnMenu, "isSelect", true, supportObj);
      }
      break;
    }
    default:
      break;
  }
}

function selectTestInEditOrder(testInEditOrder, isSelect, testNodeList) {
  let testNodeOnMenu = testNodeList.find(node => node.id === testInEditOrder.item_id);
  handleTestSelection(testNodeOnMenu, "isSelect", isSelect);
}

function selectXChooseYPanelInEditOrder(xChooseYInEditOrder, isSelect, supportObj) {
  let { testNodeList, bundleList } = supportObj;
  let xChooseYOnMenu = bundleList.find(bundle => bundle.bundleId === xChooseYInEditOrder.item_id);
  if (xChooseYOnMenu) {
    let { xChooseYDetails, supplementDetails } = xChooseYInEditOrder;
    xChooseYOnMenu.selectedZoomerIdList = xChooseYDetails.map(detail => detail.item_id);
    xChooseYOnMenu.selectedSupplementIdList = supplementDetails.map(detail => detail.item_id);
    handleXChooseYSelection(xChooseYInEditOrder.item_id, "isSelect", isSelect, supportObj);
  } else {
    // add zoomers & supplements instead
    let { xChooseYDetails, supplementDetails } = xChooseYInEditOrder;
    xChooseYDetails.concat(supplementDetails).forEach(test => {
      selectTestInEditOrder(test, isSelect, testNodeList);
    });
  }
}

// get sample types for each item & check whether edit order item is on current menu
export function getEditOrderItemSampleTypes(item, supportObj) {
  let { testNodeList, bundleList, shortcutList, seasonalPromotionList } = supportObj;
  let sampleTypeSets = {
    blood: new Set(),
    nonBlood: new Set(),
    dryIce: new Set()
  };
  let isOnMenu = false;
  switch (item.category) {
    case "va":
    case "vw": {
      let testNodeOnMenu = testNodeList.find(node => node.id === item.item_id);
      if (testNodeOnMenu) {
        sampleTypeSets = testNodeOnMenu.value.sampleTypeSets;
        isOnMenu = true;
      }
      break;
    }
    case "discountPanel":
    case "customPanel":
    case "xChooseY": {
      let panelOnMenu = bundleList.find(bundle => bundle.bundleId === item.item_id && bundle.category === item.category);
      if (panelOnMenu) {
        sampleTypeSets = panelOnMenu.sampleTypeSets;
        isOnMenu = true;
      }
      break;
    }
    case "shortcut": {
      let shortcutOnMenu = shortcutList.find(s => s.id === item.item_id);
      if (shortcutOnMenu) {
        sampleTypeSets = shortcutOnMenu.sampleTypeSets;
        isOnMenu = true;
      } 
      break;
    }
    case "seasonalPromo": {
      let seasonalPromoOnMenu = seasonalPromotionList.find(promo => promo.id === item.item_id);
      if (seasonalPromoOnMenu) {
        sampleTypeSets = seasonalPromoOnMenu.sampleTypeSets;
        isOnMenu = true;
      }
      break;
    }
    default:
      break;
  }
  return { sampleTypeSets, isOnMenu };
}

export async function handleEditOrderCoupon(editOrderSampleId, currency, coupnCode, itemList, supportObj) {
  if (!coupnCode) {
    return;
  }
  try {
    // remove coupon if no original tests in edit order
    if (itemList.length === 0) {
      store.dispatch("orderTest/order/setPromoCode", "", { root: true });
      store.dispatch("orderTest/order/setPromoDiscount", 0, { root: true });
    } else {
      let patientId = parseJson(sessionStorage.getItem("patient"))?.id ?? null;
      let payload = getVerifyCouponApiPayload(editOrderSampleId, currency, itemList, coupnCode, supportObj, patientId);
      let { data } = await verifyCouponCodeApi(payload);
      let { totalDeduction, discountType, priceDetail } = data;
      let promoDiscount = Number(totalDeduction);
      if (promoDiscount > 0) { // valid coupon
        if (discountType === "waive_concierge_fee") {
          store.dispatch("orderTest/promotions/setWaiveConciergeFee", true);
          return;
        }
        let couponDeduction = priceDetail.filter(item => !item.bundleId)
          .reduce((acc, item) => acc + (item.originalPrice - item.sellingPrice), 0);
        if (discountType === "absolute_off" && priceDetail.length ===  0) {
          couponDeduction = promoDiscount;
        }
        store.dispatch("orderTest/order/setPromoCode", coupnCode);
        store.dispatch("orderTest/order/setPromoDiscount", couponDeduction);
      } else {
        store.dispatch("orderTest/order/setPromoCode", "", { root: true });
        store.dispatch("orderTest/order/setPromoDiscount", 0, { root: true });
      }
    }
  } catch (error) {
    console.log("handleEditOrderCoupon error", error);
    store.dispatch("orderTest/order/setPromoCode", "", { root: true });
    store.dispatch("orderTest/order/setPromoDiscount", 0, { root: true });
  }
}
